import { XIcon } from 'lucide-react';
import type { ExternalToast } from 'sonner';

/**
 * The settings to add a close button to a toast.
 */
export const TOAST_CLOSE_BUTTON: Readonly<ExternalToast> = {
    cancel: {
        label: <XIcon className="size-4" />,
        onClick: () => {},
    },
    cancelButtonStyle: {
        backgroundColor: 'transparent',
        minWidth: 0,
    },
};
